// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"ModifierComposante_TableauBootstrap__4UfEA","btn_stylo":"ModifierComposante_btn_stylo__VWQft","center":"ModifierComposante_center__lx1Ha"};